import { createEnum } from "../utils/enum-util";

export const UserSyncStatus = createEnum({
    DISABLED: {
        key: "0",
        name: "Disabled",
    },
    ENABLED: {
        key: "1",
        name: "Enabled",
    },
});
